<template>
  <div v-wechat-title="titleTop">
    <van-skeleton title :row="20" :loading="loading">
      Loading...
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import commonData from '@/commondata.js'
import { Button, Skeleton } from 'vant'
import { getUrlKey, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton
  },
  data() {
    return {
      titleTop: '',
      loading: true,
      gotoUrl: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.gotoUrl = getUrlKey('url')
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loading = true
      this.setTitle()
      request({
        url: '/user/getUserHeadIcon',
        method: 'post'
      }).then(response => {
        this.loading = false
        this.setTitle()
        setTimeout(() => {
          this.setTitle()
        }, 1)
        setTimeout(() => {
          this.setTitle()
        }, 100)
        setTimeout(() => {
          this.setTitle()
        }, 1000)
        if (this.gotoUrl) {
          this.$router.push(this.gotoUrl)
        } else {
          this.$router.push('/store/index')
        }
      })
    },
    setTitle() {
      var userAgentBody = navigator.userAgent
      if (userAgentBody.indexOf('AlipayClient') > 0) {
        if (commonData && commonData.storeBase) {
          commonData.storeBase.title = '酷潜潜水中心'
        }
      }
    }
  }
}
</script>
